export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/74cc88c7571ddfe8037db442e45677ad.svg";